import { Component } from '@angular/core';
import { SectionCardInterface } from '../../data/interfaces/SectionCardInterface';
import { PUBLIC_SECURITY_CARDS } from '../../data/public-security-cards.data';
import { SectionCard } from '../section-card/section-card';

@Component({
  selector: 'app-public-security',
  imports: [SectionCard],
  templateUrl: './public-security.html',
  styleUrl: './public-security.scss',
})
export class PublicSecurity {
  cards: Array<SectionCardInterface> = PUBLIC_SECURITY_CARDS
}
